module.exports = __webpack_public_path__ + "7db83a450be6a0c34b69cc9ae70b0c49.MP3";